import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

/**
 * Instructions modal component
 *
 * @param {Object} props
 * @param {Boolean} props.isOpen
 * @param {Function} props.closeModal
 * @returns {JSX.Element}
 */
export default function ChangeDeviceModal({ isOpen, closeModal, qr }) {
    const modalRef = useRef(null);

    if (modalRef.current) {
        modalRef.current.scrollTop = 0;
    }

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-75" />
                </Transition.Child>

                <div
                    className="fixed inset-0 overflow-y-auto"
                    ref={modalRef}
                    dusk="intructions-modal"
                >
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white px-8 py-12 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-2xl text-center font-bold leading-6 text-gray-900"
                                >
                                    Ir a tu dispositivo móvil
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-base text-black text-center">
                                        Escanea este código QR con tu
                                        dispositivo móvil para tomar el test
                                        desde ahí y tus resultados sean más
                                        precisos.
                                    </p>
                                </div>

                                <div className="flex justify-center items-center mt-8">
                                    <img
                                        src={qr}
                                        alt=""
                                        dusk="qr-code"
                                        className="w-full h-auto max-w-[200px] p-4 border-2 border-primary-400"
                                    />
                                </div>

                                <div className="mt-8 flex justify-center">
                                    <button
                                        type="button"
                                        dusk="close-qr-modal"
                                        className="inline-flex outline-none justify-center border border-transparent bg-primary-400 px-4 py-2 text-sm font-medium text-white"
                                        onClick={closeModal}
                                    >
                                        CONTINUAR EN PC
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
